import {useNavigate} from "react-router-dom";
import {useContext} from "react";
import {Context} from "../index";

const SubjectBlock = ({ mean, round, subj, num, colorClass, minEsts, index }) => {
    const navigate = useNavigate();
    const {fileStore} = useContext(Context)
    const id = index
    let url;
    if (id) {
        url = `/file/${fileStore.currentFile}/${subj}?idx=${id}`
    } else {
        url = `/file/${fileStore.currentFile}/${subj}`
    }

    return (
        <div className={`subject-block ${colorClass}`} onClick={() => navigate(url)}>
            <span className="left">
                {mean}
                <span className="appr"> ~ </span>
                <span className={colorClass}>{round}</span>
            </span>
            <span className="center">{subj}</span>
            <span className="right" title={num < minEsts ? `Не хватает ${minEsts - num} оценок для аттестации в данном периоде` : ""}>
                {num < minEsts && <>*</>}
                {num} оценок
            </span>
        </div>
    );
};

export default SubjectBlock;